<template>
  <div>
    
    <Horizontal >
        <slot  />
    </Horizontal>
   
  </div>
</template>

<script setup>
 

 const nuxtApp = useNuxtApp();

 

import Horizontal from "~/components/layouts/horizontal/index.vue";

 
</script>

